import axiosPrivate from "./axiosPrivate";

const getSueldosPerfil = () => {
  return axiosPrivate.get("sueldo-perfil")
    .then(response => response.data);
};

const insertSueldoPerfil = (data) => {
  return axiosPrivate.post("sueldo-perfil", data)
    .then(response => response.data);
};

const updateSueldoPerfil = (data) => {
  return axiosPrivate.put("sueldo-perfil", data)
    .then(response => response.data);
};

const getBonosPoi = () => {
  return axiosPrivate.get("bono-poi")
    .then(response => response.data);
};

const insertBonoPoi = (data) => {
  return axiosPrivate.post("bono-poi", data)
    .then(response => response.data);
};

const updateBonoPoi = (data) => {
  return axiosPrivate.put("bono-poi", data)
    .then(response => response.data);
};

const getBonosAntiguedad = () => {
  return axiosPrivate.get("bono-antiguedad")
    .then(response => response.data);
};

const insertBonoAntiguedad = (data) => {
  return axiosPrivate.post("bono-antiguedad", data)
    .then(response => response.data);
};

const updateBonoAntiguedad = (data) => {
  return axiosPrivate.put("bono-antiguedad", data)
    .then(response => response.data);
};

const getSueldoEmpleados = (fecha, macro_area_id) => {
  return axiosPrivate.post("getSueldoEmpleados", { fecha, macro_area_id })
    .then(response => response.data);
};

const generarSueldoEmpleados = (fecha) => {
  return axiosPrivate.post("generarSueldoEmpleados", { fecha })
    .then(response => response.data);
};

const updateSueldoEmpleado = (data) => {
  return axiosPrivate.put("sueldo-empleado", data)
    .then(response => response.data);
};

export default {
  getSueldosPerfil,
  insertSueldoPerfil,
  updateSueldoPerfil,
  getBonosPoi,
  insertBonoPoi,
  updateBonoPoi,
  getBonosAntiguedad,
  insertBonoAntiguedad,
  updateBonoAntiguedad,
  getSueldoEmpleados,
  generarSueldoEmpleados,
  updateSueldoEmpleado
};
